import {
  type AriaCalendarCellProps,
  useCalendarCell,
} from "@react-aria/calendar"
import type { CalendarState } from "@react-stately/calendar"
import clsx from "clsx"
import React from "react"

import { Text } from "../Text"
import styles from "./CalendarCell.module.css"

interface Props {
  state: CalendarState
  date: AriaCalendarCellProps["date"]
}

export function CalendarCell(props: Props) {
  const { state, date } = props

  const ref = React.useRef<HTMLDivElement>(null)

  const {
    cellProps,
    buttonProps,
    isFocused,
    isSelected,
    isOutsideVisibleRange,
    formattedDate,
    isDisabled,
  } = useCalendarCell({ date }, state, ref)

  return (
    <td {...cellProps} className={styles.root}>
      <div className={styles.wrapper} {...buttonProps} ref={ref}>
        <div
          className={clsx(
            styles.cell,
            isFocused && styles.focused,
            isSelected && styles.selected,
            isDisabled && styles.disabled,
            isOutsideVisibleRange && styles.hidden,
          )}
        >
          <Text
            variant={isFocused || isSelected ? "bold" : "normal"}
            color="inherit"
            align="center"
            noWrap
          >
            {formattedDate}
          </Text>
        </div>
      </div>
    </td>
  )
}
